import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../globals';
import { DishCreateNamePage } from '../../dish/dish-create/dish-create-name/dish-create-name';
import { DishServices } from '../../dish/services';
import { CartaCreateSelectTypePage } from '../../carta/carta-create/carta-create-select-type/carta-create-select-type';
import { CartaServices } from '../../carta/services';
import { TpvLoaderPage } from '../../tpv/tpv-loader/tpv-loader';
import { DishListPage } from '../../dish/dish-list/dish-list';
import { CartaListPage } from '../../carta/carta-list/carta-list';
/**
 * Generated class for the HomeDashboardFreePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-home-dashboard-free',
  templateUrl: 'home-dashboard-free.html',
})
export class HomeDashboardFreePage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public translate: TranslateService,
    public dishServices: DishServices,
    public cartaServices: CartaServices,) {
  }

  async ngOnInit() {
    window.addEventListener('resize', function (event) {
      if (document.getElementById('dashboard_text2')) {
        var min_h = document.getElementById('dashboard_text2').clientHeight;
        document.getElementById('dashboard_text1').style.minHeight = min_h.toString() + 'px';
        document.getElementById('dashboard_text3').style.minHeight = min_h.toString() + 'px';

        min_h = document.getElementById('dashboard_text5').clientHeight;
        document.getElementById('dashboard_text4').style.minHeight = min_h.toString() + 'px';
        document.getElementById('dashboard_text6').style.minHeight = min_h.toString() + 'px';
      }
    });
    await this.globals.delay(500);
    this.changeMinHeight();
    if (this.dishServices._dishes_array_tmp.length == 0) {
      this.dishServices.getPagesDishes(50);
    }
    if (this.cartaServices.total_cartas == 0) {
      this.cartaServices.getCartas(this.globals.restaurant_uid);
    }
  }

  changeMinHeight() {
    if (document.getElementById('dashboard_text2')) {
      var min_h = document.getElementById('dashboard_text2').clientHeight;
      document.getElementById('dashboard_text1').style.minHeight = min_h.toString() + 'px';
      document.getElementById('dashboard_text3').style.minHeight = min_h.toString() + 'px';

      min_h = document.getElementById('dashboard_text5').clientHeight;
      document.getElementById('dashboard_text4').style.minHeight = min_h.toString() + 'px';
      document.getElementById('dashboard_text6').style.minHeight = min_h.toString() + 'px';
    }
  }

  createDish() {
    var total_dishes = 0;
    if (this.dishServices._dishes_array_tmp) {
      total_dishes = this.dishServices._dishes_array_tmp.length;
    }

    //Si total_dishes es mayor o igual al limite de platos, y el limite es diferente a -1
    if (total_dishes >= this.globals.checkLimitsByLicense('dishes', 'max_dishes') && this.globals.checkLimitsByLicense('dishes', 'max_dishes') != -1) {
      //this.navCtrl.push(AddonsTriggerVersionProPage);
      this.navCtrl.push(DishListPage);
    } else {
      this.dishServices.image_url_dish_view = null;
      //
      this.globals.tourLaunchStep(2);
      //
      this.globals.side_menu_active = 'dish';
      this.navCtrl.push(DishCreateNamePage, {
        update: false
      });
    }
  }

  createCarta() {
    if (this.cartaServices.total_cartas >= this.globals.checkLimitsByLicense('menus', 'max_menus') && this.globals.checkLimitsByLicense('menus', 'max_menus') != -1) { //Si limit menus
      //this.navCtrl.push(AddonsTriggerVersionProPage);
      this.navCtrl.push(CartaListPage);
    } else {//Si no limit menus
      this.globals.side_menu_active = 'carta';
      this.navCtrl.push(CartaCreateSelectTypePage);
    }
  }

  openTPV() {
    this.globals.side_menu_active = 'tpv';
    this.navCtrl.setRoot(TpvLoaderPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home-dashboard-free/home-dashboard-free.ts